import {api} from './api';

const RESOURCE_PATH = `/`;

export const CommonApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPricingPlans: builder.query<any, void>({
        query: () => `${RESOURCE_PATH}pricing-plans/`,
        providesTags: [{ type: 'PricingPlans', id: 'PRICING_PLANS' }],
    }),
  }),
});

export const { useGetPricingPlansQuery } = CommonApi;
